// Recovered compiled webpack factory 32753. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      createFetch: function () {
        return m;
      },
      createFromNextReadableStream: function () {
        return g;
      },
      fetchServerResponse: function () {
        return _;
      },
    }));
  let n = r(77197),
    a = r(52486),
    o = r(41209),
    i = r(85153),
    s = r(86871),
    l = r(16378),
    u = r(3201),
    c = r(20396),
    f = r(93223),
    d = n.createFromReadableStream;
  function p(e) {
    return {
      flightData: (0, f.urlToUrlWithoutFlightMarker)(new URL(e, location.origin)).toString(),
      canonicalUrl: void 0,
      couldBeIntercepted: !1,
      prerendered: !1,
      postponed: !1,
      staleTime: -1,
    };
  }
  let h = new AbortController();
  async function _(e, t) {
    let { flightRouterState: r, nextUrl: n, prefetchKind: o } = t,
      i = {
        [a.RSC_HEADER]: "1",
        [a.NEXT_ROUTER_STATE_TREE_HEADER]: (0, l.prepareFlightRouterStateForRequest)(
          r,
          t.isHmrRefresh,
        ),
      };
    (o === s.PrefetchKind.AUTO && (i[a.NEXT_ROUTER_PREFETCH_HEADER] = "1"),
      n && (i[a.NEXT_URL] = n));
    try {
      var c;
      let t = o ? (o === s.PrefetchKind.TEMPORARY ? "high" : "low") : "auto",
        r = await m(e, i, t, h.signal),
        n = (0, f.urlToUrlWithoutFlightMarker)(new URL(r.url)),
        d = r.redirected ? n : void 0,
        _ = r.headers.get("content-type") || "",
        y = !!(null == (c = r.headers.get("vary")) ? void 0 : c.includes(a.NEXT_URL)),
        v = !!r.headers.get(a.NEXT_DID_POSTPONE_HEADER),
        b = r.headers.get(a.NEXT_ROUTER_STALE_TIME_HEADER),
        E = null !== b ? 1e3 * parseInt(b, 10) : -1;
      if (!_.startsWith(a.RSC_CONTENT_TYPE_HEADER) || !r.ok || !r.body)
        return (e.hash && (n.hash = e.hash), p(n.toString()));
      let R = v
          ? (function (e) {
              let t = e.getReader();
              return new ReadableStream({
                async pull(e) {
                  for (;;) {
                    let { done: r, value: n } = await t.read();
                    if (!r) {
                      e.enqueue(n);
                      continue;
                    }
                    return;
                  }
                },
              });
            })(r.body)
          : r.body,
        P = await g(R);
      if ((0, u.getAppBuildId)() !== P.b) return p(r.url);
      return {
        flightData: (0, l.normalizeFlightData)(P.f),
        canonicalUrl: d,
        couldBeIntercepted: y,
        prerendered: P.S,
        postponed: v,
        staleTime: E,
      };
    } catch (t) {
      return (
        h.signal.aborted ||
          console.error(
            "Failed to fetch RSC payload for " + e + ". Falling back to browser navigation.",
            t,
          ),
        {
          flightData: e.toString(),
          canonicalUrl: void 0,
          couldBeIntercepted: !1,
          prerendered: !1,
          postponed: !1,
          staleTime: -1,
        }
      );
    }
  }
  async function m(e, t, r, n) {
    t["x-deployment-id"] = "dpl_6RLyVc3L2qK5GpvsjXmfExxYVxRH";
    let o = new URL(e);
    await (0, c.setCacheBustingSearchParam)(o, t);
    let i = await fetch(o, {
        credentials: "same-origin",
        headers: t,
        priority: r || void 0,
        signal: n,
      }),
      s = i.redirected,
      l = new URL(i.url, o);
    return (
      l.searchParams.delete(a.NEXT_RSC_UNION_QUERY),
      { url: l.href, redirected: s, ok: i.ok, headers: i.headers, body: i.body, status: i.status }
    );
  }
  function g(e) {
    return d(e, { callServer: o.callServer, findSourceMapURL: i.findSourceMapURL });
  }
  (window.addEventListener("pagehide", () => {
    h.abort();
  }),
    window.addEventListener("pageshow", () => {
      h = new AbortController();
    }),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
